/** Dashboard category See-all modal copy (title + user-facing description). */

export const CATEGORY_SEE_ALL_CREDIT_TEXT = "1 credit per image";

export const DASHBOARD_CATEGORY_MODAL_COPY = {
  2: {
    title: "Passport Photos",
    description:
      "Choose your country, upload a portrait photo, and we'll prepare it to official size requirements.",
  },
  3: {
    title: "Market Places",
    description:
      "Select a marketplace size, upload your product image, and remove the background ready for your listing.",
  },
  5: {
    title: "Dating Profile Pictures",
    description:
      "Pick a dating app, upload your photo, and get a profile-ready image at the perfect dimensions.",
  },
  6: {
    title: "Social Media",
    description:
      "Choose a social platform, upload your image, and resize it for posts, stories, or covers.",
  },
};

const DEFAULT_PRESET_PICKER_COPY = {
  label: "Image size",
  placeholder: "Choose a size",
  searchPlaceholder: "Search sizes",
  loadingText: "Loading sizes…",
  emptySearchText: "No matches for your search",
  emptyListText: "No sizes available",
};

/** User-facing dropdown copy for category See-all modals (avoid internal term "preset"). */
export const CATEGORY_PRESET_PICKER_COPY = {
  2: {
    label: "Country",
    placeholder: "Choose your country",
    searchPlaceholder: "Search countries",
    emptySearchText: "No countries match your search",
    emptyListText: "No countries available",
  },
  3: {
    label: "Marketplace",
    placeholder: "Choose a marketplace",
    searchPlaceholder: "Search marketplaces",
    emptySearchText: "No marketplaces match your search",
    emptyListText: "No marketplaces available",
  },
  5: {
    label: "Dating app",
    placeholder: "Choose a dating app",
    searchPlaceholder: "Search dating apps",
    emptySearchText: "No apps match your search",
    emptyListText: "No dating apps available",
  },
  6: {
    label: "Platform",
    placeholder: "Choose a platform",
    searchPlaceholder: "Search platforms",
    emptySearchText: "No platforms match your search",
    emptyListText: "No platforms available",
  },
};

/** User-facing dropdown copy for trending-tool upload modals. */
export const TRENDING_PRESET_PICKER_COPY = {
  edit_images_ai: {
    label: "Image size",
    placeholder: "Choose social or standard size",
    searchPlaceholder: "Search sizes or platforms",
  },
  product_catalog: {
    label: "Where you'll use it",
    placeholder: "Choose marketplace, social, or standard size",
    searchPlaceholder: "Search marketplaces or platforms",
  },
  food_catalog: {
    label: "Catalogue size",
    placeholder: "Choose food, social, or standard size",
    searchPlaceholder: "Search food or social sizes",
  },
  automobile_catalog: {
    label: "Catalogue size",
    placeholder: "Choose automobile, social, or standard size",
    searchPlaceholder: "Search automobile or social sizes",
  },
};

function mergePresetPickerCopy(overrides = {}) {
  return { ...DEFAULT_PRESET_PICKER_COPY, ...overrides };
}

export function getCategoryPresetPickerCopy(category) {
  const categoryId = category?.category_id;
  return mergePresetPickerCopy(CATEGORY_PRESET_PICKER_COPY[categoryId]);
}

export function getTrendingPresetPickerCopy(toolId) {
  return mergePresetPickerCopy(TRENDING_PRESET_PICKER_COPY[toolId]);
}

export function getCategoryModalCopy(category) {
  if (!category) {
    return { title: "", description: "" };
  }

  const configured = DASHBOARD_CATEGORY_MODAL_COPY[category.category_id];
  const apiDescription = category.description || category.category_description || "";

  return {
    title: configured?.title || category.category_name || category.category || "",
    description: configured?.description || apiDescription,
  };
}

export function getCategoryRowDescription(category) {
  if (!category) return "";
  return category.description || category.category_description || "";
}
